import { updateMessageById } from "api/messages";
import { useMutation } from "react-query";

/**
 * Hook to update a sms_messages record via API.
 *
 * @param {Object} [options={}] - Optional react-query mutation options.
 * @returns {Object} An object with `sendSMSMutation` function and react-query mutation state.
 */
export const useUpdateMessageById = (options = {}) => {
  const { mutate, mutateAsync, ...rest } = useMutation(updateMessageById, options);

  return {
    updateMessage: mutate,
    updateMessageAsync: mutateAsync,
    ...rest,
  };
};
